import React, { FC, ReactNode } from 'react';
import { CSSProperties } from 'styled-components';

type Props = {
  children: ReactNode;
  classes?: string;
  style?: CSSProperties;
  title?: string;
  withIcon?: boolean;
  renderButtons?: () => React.ReactNode;
  type?: 'INFO' | 'SUCCESS' | 'ERROR' | 'WARNING' | 'HIGHLIGHT';
  loading?: boolean;
  customColorClass?: string;
};

export const Informativo: FC<Props> = ({
  children,
  classes = '',
  style,
  title = '',
  withIcon = false,
  renderButtons,
  type,
  loading = false,
  customColorClass = ''
}) => {
  let colorClass = '';
  let iconClass = '';

  switch (type) {
    case 'INFO':
      iconClass = 'fa-info-circle';
      colorClass = 'primary';
      break;

    case 'SUCCESS':
      iconClass = 'fa-check-circle';
      colorClass = 'positive';
      break;

    case 'ERROR':
      iconClass = 'fa-times-circle';
      colorClass = 'negative';
      break;

    case 'WARNING':
      iconClass = 'fa-exclamation-triangle';
      colorClass = 'warning';
      break;

    default:
      break;
  }

  const isTextContent =
    typeof children === 'string' || typeof children === 'number';
  const childContent = loading ? 'Carregando...' : children;
  const content = isTextContent ? (
    <p style={style as any}>{childContent}</p>
  ) : (
    <div style={style as any}>{childContent}</div>
  );

  if (withIcon || renderButtons) {
    return (
      <div
        className={`info ${colorClass} ${withIcon ? 'icon' : ''} ${classes}`}
      >
        {withIcon && (
          <div className={`icon ${customColorClass}`}>
            <em
              className={`fa ${loading ? 'fa-spinner fa-spin' : iconClass}`}
            />
          </div>
        )}

        <article>
          <h4>{title}</h4>
          {content}
        </article>

        {renderButtons?.()}
      </div>
    );
  }

  return (
    <article className={`info ${colorClass} ${classes}`} style={style as any}>
      {childContent}
    </article>
  );
};
